export { HomepageHero } from "./hero";
export { HomepageCollaboration } from "./collaboration";
export { HomepageQuote } from "./quote";
export { HomepageProfessionals } from "./zorgverleners";
export { HomepageBackground } from "./background";
export { HomepageVideos } from "./videos";
export { HomepageServices } from "./services";
